import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock, createVNode as _createVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = ["data-theme"]
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { id: "ai-mate-chat-embed-div" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]

import {
  getAppInfo,
} from 'utilities';
import {
  onBeforeMount,
  onBeforeUnmount,
  onMounted,
  watch,
} from 'vue';
import {
  identifyDeviceType,
  viewportBreakpoint,
} from './helpers';
import BusNotification from '@/components/App/BusNotification.vue';
import GoogleOneTap from '@/components/App/GoogleOneTap.vue';
import LazyScript from '@/components/App/LazyScript.vue';
import CustomLoader1 from '@/components/Helper/Loader/CustomLoader1.vue';
import FooterSection from '@/components/LandingPage/FooterSection.vue';
import AppHeader from '@/components/NavBar/AppHeader.vue';
import {
  useStore,
} from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {


let storageEventHandler: (e: StorageEvent) => void;
let resizedBreakpointEventHandler: (e: Event) => void;
let themeChangeEventListener: (e: Event) => void;

const appStore = useStore.app;
const navStore = useStore.nav;
const backendStore = useStore.backend;
const utilStore = useStore.util;
const authStore = useStore.auth;

watch(() => authStore.token, (newVal, oldVal) => {
  const triggerAuthChangeHandler = (newVal && !oldVal) || (oldVal && !newVal);
  if (triggerAuthChangeHandler) {
    useStore.subscription.initOnAuthChange();
  }
});

onMounted(() => {
  backendStore.initOnAppMount();
});

onBeforeMount(() => {
  // const lightThemeMQ = window.matchMedia('(prefers-color-scheme: light)');

  // for mobile screen, overlay is minimized at mount
  if (['md', 'sm', 'xs'].includes(viewportBreakpoint())) {
    navStore.isDashboardSidebarOpen = false;
  }

  // if (!utilStore.theme) {
  //   navStore.isLightTheme = lightThemeMQ.matches;
  //   lightThemeMQ.addEventListener('change', (event) => {
  //     const lightColorScheme = event.matches;
  //     navStore.isLightTheme = lightColorScheme;
  //   });
  // } else {
  //   navStore.isLightTheme = utilStore.theme === 'light';
  // }

  navStore.isLightTheme = true;
  utilStore.theme = 'light';

  storageEventHandler = (e: StorageEvent): void => {
    if (e.key === 'token') {
      // local storage token changed
      console.log(`Key Changed: ${e.key}`);
      window.sessionStorage.removeItem('token');
      window.location.reload();
    }
  };
  resizedBreakpointEventHandler = (e: Event): void => {
    const device = identifyDeviceType();
    appStore.breakpoint = viewportBreakpoint();
    appStore.device = device;
    appStore.windowWidth = window.innerWidth;
  };

  window.addEventListener('resize', resizedBreakpointEventHandler);
  window.addEventListener('storage', storageEventHandler);
});

onBeforeUnmount(() => {
  window.removeEventListener('storage', storageEventHandler);
  window.removeEventListener('resize', resizedBreakpointEventHandler);
  window.removeEventListener('change', themeChangeEventListener);
});

return (_ctx: any,_cache: any) => {
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createElementBlock("div", {
    class: "relative min-h-screen flex-col overflow-x-hidden font-Heebo",
    "data-theme": _unref(navStore).isLightTheme ? 'light' : 'dracula'
  }, [
    (_unref(appStore).isBootstrapped)
      ? (_openBlock(), _createBlock(LazyScript, { key: 0 }))
      : _createCommentVNode("", true),
    (!_unref(getAppInfo)().CONFIG.webPayment.isProduction)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4, 512)), [
          [_vShow, !_unref(authStore).token]
        ])
      : _createCommentVNode("", true),
    (_unref(appStore).isBootstrapped)
      ? (_openBlock(), _createBlock(AppHeader, { key: 2 }))
      : _createCommentVNode("", true),
    _createElementVNode("main", null, [
      _createVNode(BusNotification),
      _createVNode(GoogleOneTap),
      _createElementVNode("div", null, [
        (_unref(appStore).isLoading)
          ? (_openBlock(), _createBlock(CustomLoader1, {
              key: 0,
              class: "modal modal-open"
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_RouterView)
      ])
    ]),
    (!_unref(appStore).isLoading)
      ? (_openBlock(), _createBlock(FooterSection, { key: 3 }))
      : _createCommentVNode("", true)
  ], 8, _hoisted_1))
}
}

})